import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";

export async function fetchOrderById(id, status) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL(`/admin/product-order-parents/${id}`, baseUrl);
  if (status) {
    endpointUrl.searchParams.append("status", status);
  }
  const { data } = await http(endpointUrl.toString().replace(baseUrl, ""));

  return data;
}

export function useOrderDetail(id, status) {
  const { data, ...raResult } = useQuery(
    ["product-order-parents", status],
    () => fetchOrderById(id, status)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
